// eslint-disable-next-line import/prefer-default-export
export const selectAddressByType = (addresses, type) =>
  addresses?.find(address => address.addressType === type);

export const hasCitiesAvailable = (addressData, isLoadingAddress) => {
  return !isLoadingAddress && 
    addressData.cities && 
    addressData.cities.length > 0 && 
    addressData.cities.some(city => city && city.trim() !== '');
};